import { render, staticRenderFns } from "./MenuRodape.vue?vue&type=template&id=d3584cbe&scoped=true&"
import script from "./MenuRodape.vue?vue&type=script&lang=js&"
export * from "./MenuRodape.vue?vue&type=script&lang=js&"
import style0 from "./MenuRodape.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MenuRodape.vue?vue&type=style&index=1&id=d3584cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3584cbe",
  null
  
)

export default component.exports